/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicVerifyLinkRouteImport } from './routes/_public/verify-link'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as AuthUsersRouteImport } from './routes/_auth/users'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthRecommendationsRouteImport } from './routes/_auth/recommendations'
import { Route as AuthIntegrationRouteImport } from './routes/_auth/integration'
import { Route as AuthGroupsRouteImport } from './routes/_auth/groups'
import { Route as AuthEmployeesRouteImport } from './routes/_auth/employees'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'

const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicVerifyLinkRoute = PublicVerifyLinkRouteImport.update({
  id: '/verify-link',
  path: '/verify-link',
  getParentRoute: () => PublicRoute,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const AuthUsersRoute = AuthUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRecommendationsRoute = AuthRecommendationsRouteImport.update({
  id: '/recommendations',
  path: '/recommendations',
  getParentRoute: () => AuthRoute,
} as any)
const AuthIntegrationRoute = AuthIntegrationRouteImport.update({
  id: '/integration',
  path: '/integration',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGroupsRoute = AuthGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AuthRoute,
} as any)
const AuthEmployeesRoute = AuthEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/dashboard': typeof AuthDashboardRoute
  '/employees': typeof AuthEmployeesRoute
  '/groups': typeof AuthGroupsRoute
  '/integration': typeof AuthIntegrationRoute
  '/recommendations': typeof AuthRecommendationsRoute
  '/settings': typeof AuthSettingsRoute
  '/users': typeof AuthUsersRoute
  '/login': typeof PublicLoginRoute
  '/verify-link': typeof PublicVerifyLinkRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/error': typeof ErrorRoute
  '/dashboard': typeof AuthDashboardRoute
  '/employees': typeof AuthEmployeesRoute
  '/groups': typeof AuthGroupsRoute
  '/integration': typeof AuthIntegrationRoute
  '/recommendations': typeof AuthRecommendationsRoute
  '/settings': typeof AuthSettingsRoute
  '/users': typeof AuthUsersRoute
  '/login': typeof PublicLoginRoute
  '/verify-link': typeof PublicVerifyLinkRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/error': typeof ErrorRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/employees': typeof AuthEmployeesRoute
  '/_auth/groups': typeof AuthGroupsRoute
  '/_auth/integration': typeof AuthIntegrationRoute
  '/_auth/recommendations': typeof AuthRecommendationsRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/users': typeof AuthUsersRoute
  '/_public/login': typeof PublicLoginRoute
  '/_public/verify-link': typeof PublicVerifyLinkRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/error'
    | '/dashboard'
    | '/employees'
    | '/groups'
    | '/integration'
    | '/recommendations'
    | '/settings'
    | '/users'
    | '/login'
    | '/verify-link'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/error'
    | '/dashboard'
    | '/employees'
    | '/groups'
    | '/integration'
    | '/recommendations'
    | '/settings'
    | '/users'
    | '/login'
    | '/verify-link'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_public'
    | '/error'
    | '/_auth/dashboard'
    | '/_auth/employees'
    | '/_auth/groups'
    | '/_auth/integration'
    | '/_auth/recommendations'
    | '/_auth/settings'
    | '/_auth/users'
    | '/_public/login'
    | '/_public/verify-link'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  ErrorRoute: typeof ErrorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/verify-link': {
      id: '/_public/verify-link'
      path: '/verify-link'
      fullPath: '/verify-link'
      preLoaderRoute: typeof PublicVerifyLinkRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/recommendations': {
      id: '/_auth/recommendations'
      path: '/recommendations'
      fullPath: '/recommendations'
      preLoaderRoute: typeof AuthRecommendationsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/integration': {
      id: '/_auth/integration'
      path: '/integration'
      fullPath: '/integration'
      preLoaderRoute: typeof AuthIntegrationRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/groups': {
      id: '/_auth/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AuthGroupsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/employees': {
      id: '/_auth/employees'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof AuthEmployeesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthEmployeesRoute: typeof AuthEmployeesRoute
  AuthGroupsRoute: typeof AuthGroupsRoute
  AuthIntegrationRoute: typeof AuthIntegrationRoute
  AuthRecommendationsRoute: typeof AuthRecommendationsRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthUsersRoute: typeof AuthUsersRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthDashboardRoute: AuthDashboardRoute,
  AuthEmployeesRoute: AuthEmployeesRoute,
  AuthGroupsRoute: AuthGroupsRoute,
  AuthIntegrationRoute: AuthIntegrationRoute,
  AuthRecommendationsRoute: AuthRecommendationsRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthUsersRoute: AuthUsersRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
  PublicVerifyLinkRoute: typeof PublicVerifyLinkRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
  PublicVerifyLinkRoute: PublicVerifyLinkRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  ErrorRoute: ErrorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
